const menu = [
  {
    name: "Produkty",
    link: "/produkty/wszystkie",
  },
  {
    name: "Zaufali nam",
    link: "/zaufali-nam",
  },
  {
    name: "Współpraca",
    link: "/współpraca",
  },
  {
    name: "Do pobrania",
    link: "/do-pobrania",
  },
  {
    name: "Dla Inwestorów",
    link: "/inwestorzy",
  },
  {
    name: "Kontakt",
    link: "/kontakt",
  },

];

const lang = {
  name: 'en',
  link: 'https://rcmedical.eu/'
}

export { menu, lang };